var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addon-product-container" }, [
    _c(
      "div",
      {
        staticClass: "product-image-container",
        class: [
          _vm.canAddMore == false && this.currentQty == 0
            ? "disabled"
            : "available",
          _vm.isCorporate ? "corporate" : ""
        ]
      },
      [
        _vm.mainBadge != null
          ? _c("img", {
              staticClass: "main-badge",
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/diverse.svg?v=1683569569"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.secondaryBadge != null && !_vm.isPride
          ? _c("span", { staticClass: "secondary-badge" }, [
              _vm._v(_vm._s(_vm.secondaryBadge))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isPride
          ? _c("img", {
              staticClass: "pride-badge",
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/Pride_badge.svg?v=1717085583"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          staticClass: "lazyload main-image",
          attrs: {
            src:
              "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
            width: "270",
            height: "270",
            loading: "lazy",
            src: _vm._f("getProductImage")(_vm.product)
          },
          on: {
            click: function($event) {
              return _vm.loadModal()
            }
          }
        }),
        _vm._v(" "),
        _vm.product.images.length > 1
          ? _c("img", {
              staticClass: "hover-image",
              attrs: { src: _vm.product.images[1].src },
              on: {
                click: function($event) {
                  return _vm.loadModal()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.canAddMore == false && this.currentQty == 0
          ? _c("div", { staticClass: "limit-alert" }, [
              _vm._v(_vm._s(_vm.limitMessage))
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentQty == 0,
            expression: "currentQty == 0"
          }
        ],
        staticClass: "happybox-button white border",
        attrs: { disabled: _vm.canAddMore == false },
        on: {
          click: function($event) {
            return _vm.updateProductQuantity(true)
          }
        }
      },
      [_vm._v(_vm._s(_vm.addCopy))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentQty > 0,
            expression: "currentQty > 0"
          }
        ],
        staticClass: "quantity-container",
        class: !_vm.canAddMore ? "no-more" : ""
      },
      [
        _c(
          "button",
          {
            on: {
              mousedown: _vm.startDecrement,
              mouseup: _vm.stopDecrement,
              mouseleave: _vm.stopDecrement,
              touchstart: _vm.startDecrement,
              touchend: _vm.stopDecrement,
              click: function($event) {
                $event.preventDefault()
                return _vm.handleDecrementClick($event)
              }
            }
          },
          [_vm._v("-")]
        ),
        _vm._v(" "),
        !_vm.isEditing
          ? _c("p", { on: { click: _vm.enableEditing } }, [
              _vm._v(_vm._s(_vm.currentQty) + " per box")
            ])
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputQty,
                  expression: "inputQty"
                }
              ],
              ref: "quantityInput",
              attrs: { type: "number" },
              domProps: { value: _vm.inputQty },
              on: {
                blur: _vm.addSpecificQty,
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.addSpecificQty($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.inputQty = $event.target.value
                }
              }
            }),
        _vm._v(" "),
        _c(
          "button",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: { content: _vm.limitMessage, container: false },
                expression: "{content: limitMessage, container: false}"
              }
            ],
            on: {
              mousedown: _vm.startIncrement,
              mouseup: _vm.stopIncrement,
              mouseleave: _vm.stopIncrement,
              touchstart: _vm.startIncrement,
              touchend: _vm.stopIncrement,
              click: function($event) {
                $event.preventDefault()
                return _vm.handleIncrementClick($event)
              }
            }
          },
          [_vm._v("+")]
        )
      ]
    ),
    _vm._v(" "),
    _c("p", { staticClass: "product-title" }, [
      _vm._v(_vm._s(_vm.product.title))
    ]),
    _vm._v(" "),
    _vm.valuePrice
      ? _c("p", { staticClass: "cost" }, [
          _vm._v(
            "Value: " +
              _vm._s(_vm._f("moneySaleFormat")(_vm.valuePrice.value_price))
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "product-price-container" }, [
      _vm.hasComparePrice != null
        ? _c("span", { staticClass: "discount-price" }, [
            _vm._v(_vm._s(_vm._f("moneySaleFormat")(_vm.hasComparePrice)))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "price" }, [
        _vm._v(_vm._s(_vm._f("moneySaleFormat")(_vm.productPrice)))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }